import React from 'react';
import MapView, { Marker, MapConstant, MapControls } from '../../../../../lib/Map';
import { withStyles, withTheme } from '@material-ui/core';
import { compose } from 'recompose';
import { TerminalMarker, ShipmentsMarker } from '../../../../mapComponents/Markers';
import { withAppConfig } from '../../../../../appConfigContext';
import { withUserProfile } from '../../../../../userProfile/userProfileContext';
import Events from '../../../../../utilities/EventEmitter';
import StyledToolTip from '../../../../common/StyledToolTip';
import appConstant from '../../../../../appConstants';
import DrawStyles from '../../../../../lib/Map/Trimble/components/DrawStyles';
import DrawingTools from '../../../Settings/common/DrawTools/DrawingTools';
import MapDrawingToolBox from '../../../Settings/common/DrawTools/DrawingToolsBox';
import { GeoCode } from '../../../../../layout/layoutHeader/components';

const styles = (theme) => ({
  headerStyle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 10,
    fontSize: theme.headerTextFontSize,
    lineHeight: '16px',
    color: theme.HeaderSelectedText,
    border: `1px solid ${theme.AppBGColor}`,
    borderRadius: '4px 4px 0 0',
  },
  label: {
    marginLeft: 6,
    fontWeight: 600
  },
  mapToolBoxStyle: {
    float: 'right',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    height: '19px',
    [theme.breakpoints.down('md')]: {
      padding: '3px 8px'
    }
  },
  mapContainer: { height: 'calc(95% - 15px)' }
});

class EditCustomerMap extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      geoDataList: [],
      zoneInfo: null
    };
  }

  componentDidMount() {
    if (this.props.enableGeofence) {
      const geoJson = this.getExistingFeaturesGeoJSON();
      this.setState({
        geoDataList: geoJson,
      });
    }
  
  }

  componentDidUpdate(prevProps) {
    if (this.props.customerGeoFencing !== prevProps.customerGeoFencing && this.props.enableGeofence)  {
      const geoJson = this.getExistingFeaturesGeoJSON();
      this.setState({
        geoDataList: geoJson
      });
    }
  }
  getExistingFeaturesGeoJSON = () => {
    const { customer, customerGeoFencing } = this.props;
    return customerGeoFencing
      ? [
          {
            id: customer?.customerId || 'new',
            type: 'Feature',
            properties: {},
            geometry: {
              type: 'Polygon',
              coordinates: [JSON.parse(customerGeoFencing)]
            }
          }
        ]
      : [];
  };

  onScaleDrawingComplete = (feature, type) => {
    if ([MapConstant.DRAWING_EVENTS.CREATE, MapConstant.DRAWING_EVENTS.UPDATE].includes(type)) {
      this.props.customerGeoFencingChange(JSON.stringify(feature.geometry.coordinates[0]));
    } else if (type === 'delete') {
      this.props.customerGeoFencingChange(null);
    }
  };

  render() {
    const {
      theme,
      customer,
      classes,
      customerGeoFencing,
      glEventHub,
      gridHeaderId,
      showGeocodeControl,
    } = this.props;
    this.terminalLocation =
      this.props.userData.userProfile && this.props.userData.userProfile.terminal.location;
    this.mapCenter = {
      lat: customer.latitude,
      lng: customer.longitude
    };
    const stack={ layoutManager: { eventHub: glEventHub } };
    return (
      <>
        <div className={classes.headerStyle}>
          <span className={classes.label}>Customer Map</span>

          <span className={classes.mapToolBoxStyle}>
            {customer ? (
              <>
                {showGeocodeControl && (
                  <GeoCode headerId={gridHeaderId} stack={stack} isEnabled />
                )}
                {this.props.enableGeofence && (
                  <MapDrawingToolBox
                    lasso
                    delete
                    disableDraw={customer.isMiscCustomer}
                  />
                )}
              </>
            ) : null}
          </span>
        </div>
        <div className={classes.mapContainer}>
          <MapView
            zoom={19}
            initialCenter={this.mapCenter}
            onClick={this.onMapClicked}
            mapId={appConstant.mapIds.EDIT_CUSTOMER_MAP}
            mapTheme={theme.themeName}
            center={this.mapCenter}
            eventHub={this.props.glEventHub}
            mapConfig={this.props.configJSON?.maps}
          >
            <MapControls
              controlOptions={{
                zoomControl: {
                  position: MapConstant.CONTROL_POSITION.BOTTOM_RIGHT,
                },
                satelliteViewControl: {
                  position: MapConstant.CONTROL_POSITION.BOTTOM_RIGHT,
                },
                reCenterMapControl: {
                  position: MapConstant.CONTROL_POSITION.BOTTOM_RIGHT,
                },
              }}
            />
            <Marker
              position={this.terminalLocation}
              onClick={this.onTerminalClicked}
              animation
              anchorPoint={{ x: 20, y: 20 }}
              zIndex={1}
            >
              <TerminalMarker
                data={this.props.userData.userProfile.terminal}
                color={theme.terminalContentColor}
              />
            </Marker>
            {customer ? (
              <Marker
                data={customer}
                position={{
                  lat: customer.latitude,
                  lng: customer.longitude,
                }}
                key={`${customer.code}`}
                isActiveShipment={true}
                zIndex={1}
              >
                <StyledToolTip title={customer.name}>
                  <div>
                    <ShipmentsMarker
                      dimension={"35px"}
                      backgroundColor={appConstant.Colors.markerActiveColor}
                    />
                  </div>
                </StyledToolTip>
              </Marker>
            ) : null}

            {customer && !customer.isMiscCustomer ? (
              <DrawingTools
                polygonOptions={{
                  fillColor: theme.MapDrawingColor,
                  strokeColor: theme.MapDrawingColor,
                }}
                geoDataList={this.state.geoDataList}
                styleArray={DrawStyles()}
                eventHub={Events}
                featureIds={customer.customerId}
                onDrawingComplete={this.onScaleDrawingComplete}
                mode={customerGeoFencing ? "create" : "edit"}
              />
            ) : null}
          </MapView>
        </div>
      </>
    );
  }
}

export default compose(
  withTheme(),
  withStyles(styles),
  withUserProfile,
  withAppConfig
)(EditCustomerMap);
